import { useUtils } from "@/app/hooks/useUtils";
import clsx from "clsx";

const ServiceName: React.FC<{ serviceId: string; className?: string }> = (props) => {
  const { getService } = useUtils();
  const service = getService(props?.serviceId);

  return <span className={clsx(props?.className)}>{service?.service_name}</span>;
};
export default ServiceName;
